import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { SettingsContext } from "../../contexts";
import { TYPE_FAVOURITE_PRODUCTS } from "../../contexts/Favourites";
import { Star } from "../../components";
import { Button } from "../ui";
import { getFileUrl } from "../../core/config/api.js";

const ProductListItem = ({
  product,
  onActionButtonClick,
  // Label for the action button. Defaults to "View" (opens preview popup via
  // the Link wrapper); V2SearchProduct overrides to "Select" so the button
  // directly triggers the ORDER/SELL action without opening the popup.
  actionButtonLabel = "View",
  // When true, render the action button as a real <button> with onClick
  // (skips the <Link to=?preview=...> wrapper). The image stays clickable
  // and still opens the preview popup so users can still inspect the product.
  actionAsButton = false,
  isQuickSearch = false,
  requestType,
}) => {
  const settings = useContext(SettingsContext);

  const subParts = ["dial_color", "case_diameter"]
    .map((f) => product.values?.[f])
    .filter(Boolean);

  const metaParts = [product.reference_number, product.brand_name].filter(Boolean);

  const getPreviewLocation = (location) => ({
    ...location,
    search: `?preview=${product.id}&requestType=${requestType}&${settings.iframeQueryParams}`,
  });

  // Quick-search keeps the legacy compact card shape — embedded in the
  // global header search with its own width/positioning rules.
  if (isQuickSearch) {
    return (
      <div className="listing vertical">
        <Star item={product} type={TYPE_FAVOURITE_PRODUCTS} />
        <Link to={(location) => getPreviewLocation(location)}>
          <div className="image">
            {product.image_id > 0 && (
              <img src={getFileUrl(product.image_id)} />
            )}
          </div>
          <div className="brand-model-spacer">
            <h3>{product.brand_name}</h3>
            <h4 className="suspension-points">{product.model_name}</h4>
          </div>
          <div style={{ minHeight: "70px" }} className="d-flex">
            <p className="align-self-center description suspension-points">
              {subParts.join(" / ")}
            </p>
          </div>
          <h5 className="product-ref suspension-points">
            {product.reference_number}
          </h5>
        </Link>
      </div>
    );
  }

  return (
    <div className="pcard">
      <Star item={product} type={TYPE_FAVOURITE_PRODUCTS} />
      <div className="pcard__meta">
        {metaParts.map((p, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span className="pcard__bullet">•</span>}
            <span>{p}</span>
          </React.Fragment>
        ))}
      </div>
      <div className="pcard__name">{product.model_name || ""}</div>
      {subParts.length > 0 && (
        <div className="pcard__sub">{subParts.join(" / ")}</div>
      )}
      <Link
        to={(location) => getPreviewLocation(location)}
        className="pcard__img-link"
      >
        <div className="pcard__img">
          {product.image_id > 0
            ? <img src={getFileUrl(product.image_id)} alt={product.model_name || ""} />
            : null}
        </div>
      </Link>
      {typeof onActionButtonClick === "function" && (
        <div className="pcard__foot">
          {actionAsButton ? (
            <Button variant="secondary" fullWidth data-btn="product-select-confirm" onClick={onActionButtonClick}>
              {actionButtonLabel}
            </Button>
          ) : (
            <Button variant="secondary" fullWidth data-btn="product-open" to={(location) => getPreviewLocation(location)}>
              {actionButtonLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductListItem;
